import React from "react";
import {Outlet} from "react-router-dom";
import {ProjectProvider} from "../context/ProjectContext";
import {NavigationBlockerContextProvider} from "../context/navigationBlockerContext";


const ProjectsLoaderWrapper = () => {
    return (
        <NavigationBlockerContextProvider>
            <ProjectProvider>
                <Outlet/>
            </ProjectProvider>
        </NavigationBlockerContextProvider>
    );
}

export default ProjectsLoaderWrapper;